import React from 'react';
import {AppLayout} from 'sections/services-marketplace/experts/components';
import {
  TextContainer,
  SkeletonDisplayText,
  SkeletonBodyText,
  Card,
} from '@shopify/polaris';

import styles from './RelatedServices.scss';

export function SkeletonRelatedServices() {
  return (
    <div className={styles.RelatedServicesContainer}>
      <AppLayout.Container subdued slim>
        <AppLayout.Section fill>
          <div className={styles.RelatedServices}>
            <SkeletonDisplayText size="large" />
            <div className={styles.Grid}>
              {[...Array(3).keys()].map(key => (
                <div key={key}>
                  <Card sectioned>
                    <TextContainer>
                      <SkeletonDisplayText size="small" />
                      <SkeletonBodyText lines={3} />
                    </TextContainer>
                  </Card>
                </div>
              ))}
            </div>
          </div>
        </AppLayout.Section>
      </AppLayout.Container>
    </div>
  );
}
